export enum PaymentMethod {
  Card = "Cartão",
  Boleto = "Boleto",
  Pix = "Pix",
}
